import axios from 'axios';
import { Field, Form, Formik } from 'formik';
import React from 'react';
import { Button, Col, Row } from "react-bootstrap";
import { injectIntl } from 'react-intl';
import { useMutation } from 'react-query';
import Alert from "react-s-alert";
import {
  Input as FormikInput
} from "../../formik";


const SpeakerLogin = ({ intl, eventSlug, setToken }) => {
  const [speakerLogin, { isLoading: speakerLoginLoading }] = useMutation(({ creds }) => axios({
    url: `${process.env.REACT_APP_API_HOST}/speaker/login`,
    method: 'POST',
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    data: creds
  }).then(response => response.data), {
    onSuccess: (response) => {
      Alert.closeAll();
      setToken(response.jwt);
    },
    onError: (error) => {
      Alert.closeAll();
      Alert.error("Invalid credentials.")
    }
  })

  return (
    <Row>
      <Col md={5} className="mx-auto">
        <div className="login-left text-center">
          <h3 className="text-primary">Speaker Login</h3>
          <Formik
            initialValues={
              {
                email: '',
                password: ''
              }
            }
            onSubmit={(values) => {
              Alert.warning(intl.formatMessage({ id: "user.authenticating" }));
              speakerLogin({
                creds: {
                  ...values,
                  event_slug: eventSlug
                }
              })
            }}
          >
            {({ values }) => {
              return (
                <Form>
                  <Field
                    component={FormikInput}
                    type="email"
                    name="email"
                    placeholder={`${intl.formatMessage({
                      id: "input.email"
                    })}*`}
                    required
                  />
                  <Field
                    component={FormikInput}
                    type="password"
                    name="password"
                    placeholder={`${intl.formatMessage({
                      id: "input.password"
                    })}*`}
                    required
                  />
                  <Button
                    type="submit"
                    className=""
                    disabled={speakerLoginLoading}
                  >
                    {intl.formatMessage({
                      id: "button.login"
                    })}
                  </Button>
                </Form>
              )
            }}
          </Formik>
        </div>
      </Col>
    </Row>
  )
}

export default injectIntl(SpeakerLogin);